import React, {Component,PropTypes} from 'react'



class Horario extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value:props.value,
      posicio:0,
      lunes_estado:true,
      lunes_horario_manana_apertura: "",
      lunes_horario_manana_cierre: "",
      lunes_horario_tarde_apertura: "",
      lunes_horario_tarde_cierre: "",

      martes_estado:true,
      martes_horario_manana_apertura: "",
      martes_horario_manana_cierre: "",
      martes_horario_tarde_apertura: "",
      martes_horario_tarde_cierre: "",

      miercoles_estado:true,
      miercoles_horario_manana_apertura: "",
      miercoles_horario_manana_cierre: "",
      miercoles_horario_tarde_apertura: "",
      miercoles_horario_tarde_cierre: "",

      jueves_estado:true,
      jueves_horario_manana_apertura: "",
      jueves_horario_manana_cierre: "",
      jueves_horario_tarde_apertura: "",
      jueves_horario_tarde_cierre: "",

      viernes_estado:true,
      viernes_horario_manana_apertura: "",
      viernes_horario_manana_cierre: "",
      viernes_horario_tarde_apertura: "",
      viernes_horario_tarde_cierre: "",

      sabado_estado:false,
      sabado_horario_manana_apertura: "",
      sabado_horario_manana_cierre: "",
      sabado_horario_tarde_apertura: "",
      sabado_horario_tarde_cierre: "",

      domingo_estado:false,
      domingo_horario_manana_apertura: "",
      domingo_horario_manana_cierre: "",
      domingo_horario_tarde_apertura: "",
      domingo_horario_tarde_cierre: "",

    
    };
   
    this.handleChange=this.handleChange.bind(this);
    this.handleChangetoogle=this.handleChangetoogle.bind(this);
  }



  handleChange(myposicio,event) {

    var stringfrequpdate = this.state.value ;
    var arraystringfrequpdate = stringfrequpdate.split(",");
    console.log("valor posicio",myposicio);
    arraystringfrequpdate[myposicio] = event.target.value;
    var updatehorario = arraystringfrequpdate.toString();
    this.setState({value: updatehorario});
    console.log(event.target.value);
    this.props.updateAction(this.props.theKey,updatehorario);
    
  }



  handleChangetoogle(myposicio,valor,event) {

    var stringfrequpdate = this.state.value ;
    var arraystringfrequpdate = stringfrequpdate.split(",");
    console.log("valor posicio",myposicio);
    console.log("valor toogle",valor);

    if (valor == "true") {

      arraystringfrequpdate[myposicio] = false;  

    } else {


      arraystringfrequpdate[myposicio] = true; 

    } 

    var updatehorario = arraystringfrequpdate.toString();
    this.setState({value: updatehorario});
    console.log(event.target.value);
    this.props.updateAction(this.props.theKey,updatehorario);
    
  }



  displaytoogle(dia,valor,cambio){
 
    var evento;

   return(

    <div className="form-group label-floating is-empty">
    <label className="control-label"></label>
    <div className="togglebutton" >
    <label>
     <input type="checkbox"  value={valor} checked={valor === "true"} onChange={(e) => this.handleChangetoogle(cambio,valor, e)} />
     <span className="toggle" ></span> {dia}
    </label>
   </div>
   </div>

   )

    
  }
 


  displayhoras(tiempo,valor,cambio){
    var e;

    return (

      <div className="form-group label-floating is-empty">
             <label className="control-label"></label>          

             <select className="form-control" value={valor} onChange={(e) => this.handleChange(cambio, e)}>


       
        
         
                     <option value="1">1</option>
                     <option value="2">2</option>
                     <option value="3">3</option>
                     <option value="4">4</option>
                     <option value="5">5</option>
                     <option value="6">6</option>
                     <option value="7">7</option>
                     <option value="8">8</option>
                     <option value="9">9</option>
                     <option value="10">10</option>
                     <option value="11">11</option>
                     <option value="12">12</option>
                     <option value="13">13</option>
                     <option value="14">14</option>
                     <option value="15">15</option>
                     <option value="16">16</option>
                     <option value="17">17</option>
                     <option value="18">18</option>
                     <option value="19">19</option>
                     <option value="20">20</option>
                     <option value="21">21</option>
                     <option value="22">22</option>
                     <option value="23">23</option>
                     <option value="24">24</option>


                     </select>

                     <span className="form-control">{tiempo} </span>
            </div>



    )
  }



createArrayString(){

    var stringfreq = this.state.value ;
    console.log("el string es",stringfreq);

    var arraystringfreq = stringfreq.split(",");
   
         this.state.lunes_estado = arraystringfreq[0];
         this.state.lunes_horario_manana_apertura = arraystringfreq[1];
         this.state.lunes_horario_manana_cierre = arraystringfreq[2];
         this.state.lunes_horario_tarde_apertura = arraystringfreq[3];
         this.state.lunes_horario_tarde_cierre = arraystringfreq[4];


         this.state.martes_estado = arraystringfreq[5];
         this.state.martes_horario_manana_apertura = arraystringfreq[6];
         this.state.martes_horario_manana_cierre = arraystringfreq[7];
         this.state.martes_horario_tarde_apertura = arraystringfreq[8];
         this.state.martes_horario_tarde_cierre = arraystringfreq[9];

         this.state.miercoles_estado = arraystringfreq[10];
         this.state.miercoles_horario_manana_apertura = arraystringfreq[11];
         this.state.miercoles_horario_manana_cierre = arraystringfreq[12];
         this.state.miercoles_horario_tarde_apertura = arraystringfreq[13];
         this.state.miercoles_horario_tarde_cierre = arraystringfreq[14];


         this.state.jueves_estado = arraystringfreq[15];
         this.state.jueves_horario_manana_apertura = arraystringfreq[16];
         this.state.jueves_horario_manana_cierre = arraystringfreq[17];
         this.state.jueves_horario_tarde_apertura = arraystringfreq[18];
         this.state.jueves_horario_tarde_cierre = arraystringfreq[19];


         this.state.viernes_estado = arraystringfreq[20];
         this.state.viernes_horario_manana_apertura = arraystringfreq[21];
         this.state.viernes_horario_manana_cierre = arraystringfreq[22];
         this.state.viernes_horario_tarde_apertura = arraystringfreq[23];
         this.state.viernes_horario_tarde_cierre = arraystringfreq[24];



         this.state.sabado_estado = arraystringfreq[25];
         this.state.sabado_horario_manana_apertura = arraystringfreq[26];
         this.state.sabado_horario_manana_cierre = arraystringfreq[27];
         this.state.sabado_horario_tarde_apertura = arraystringfreq[28];
         this.state.sabado_horario_tarde_cierre = arraystringfreq[29];


         this.state.domingo_estado = arraystringfreq[30];
         this.state.domingo_horario_manana_apertura = arraystringfreq[31];
         this.state.domingo_horario_manana_cierre = arraystringfreq[32];
         this.state.domingo_horario_tarde_apertura = arraystringfreq[33];
         this.state.domingo_horario_tarde_cierre = arraystringfreq[34];


         
 }



  render() {

    
  
             
        return (


      <div className="form-group label-floating is-empty">

      {this.createArrayString(this.state.value)}

               {this.displaytoogle("Lunes",this.state.lunes_estado,0)}
               

               <div className="row">
               
               <div className="col-md-3">
               {this.displayhoras("Apertura Mañana",this.state.lunes_horario_manana_apertura,1)}
              </div>
              <div className="col-md-3">
              {this.displayhoras("Cierre Mañana",this.state.lunes_horario_manana_cierre,2)}
             </div>
             <div className="col-md-3">
             {this.displayhoras("Apertura Tarde",this.state.lunes_horario_tarde_apertura,3)}
             </div>
             <div className="col-md-3">
             {this.displayhoras("Cierre Tarde",this.state.lunes_horario_tarde_cierre,4)} 
             </div>


               </div>

                                                        

               {this.displaytoogle("Martes",this.state.martes_estado,5)}


               <div className="row">
               
               <div className="col-md-3">

              {this.displayhoras("Apertura Mañana",this.state.martes_horario_manana_apertura,6)}

              </div>
              <div className="col-md-3">
              {this.displayhoras("Cierre Mañana",this.state.martes_horario_manana_cierre,7)}
              </div>
              <div className="col-md-3">

              {this.displayhoras("Apertura Tarde",this.state.martes_horario_tarde_apertura,8)}
              </div>
              <div className="col-md-3">
               {this.displayhoras("Cierre Tarde",this.state.martes_horario_tarde_cierre,9)}
               </div>

               </div>



               {this.displaytoogle("Miércoles",this.state.miercoles_estado,10)}


               <div className="row">
               
                  <div className="col-md-3">

                     {this.displayhoras("Apertura Mañana",this.state.miercoles_horario_manana_apertura,11)}
                 </div>
                 <div className="col-md-3">
                    {this.displayhoras("Cierre Mañana",this.state.miercoles_horario_manana_cierre,12)}
                 </div>
                 <div className="col-md-3">
                    {this.displayhoras("Apertura Tarde",this.state.miercoles_horario_tarde_apertura,13)}
                 </div>
                 <div className="col-md-3">
                    {this.displayhoras("Cierre Tarde",this.state.miercoles_horario_tarde_cierre,14)}
               </div>
 
              </div>




               {this.displaytoogle("Jueves",this.state.jueves_estado,15)}

               <div className="row">
               
               <div className="col-md-3">

                     {this.displayhoras("Apertura Mañana",this.state.jueves_horario_manana_apertura,16)}

                </div>
                 <div className="col-md-3">
               
              {this.displayhoras("Cierre Mañana",this.state.jueves_horario_manana_cierre,17)}

              </div>
                 <div className="col-md-3">


              {this.displayhoras("Apertura Tarde",this.state.jueves_horario_tarde_apertura,18)}

              </div>
                 <div className="col-md-3">

               {this.displayhoras("Cierre Tarde",this.state.jueves_horario_tarde_cierre,19)}
 
              </div>
 
              </div>


               {this.displaytoogle("Viernes",this.state.viernes_estado,20)}

               <div className="row">
               
               <div className="col-md-3">



              {this.displayhoras("Apertura Mañana",this.state.viernes_horario_manana_apertura,21)}
              </div>
                 <div className="col-md-3">


              {this.displayhoras("Cierre Mañana",this.state.viernes_horario_manana_cierre,22)}
              </div>
                 <div className="col-md-3">
              {this.displayhoras("Apertura Tarde",this.state.viernes_horario_tarde_apertura,23)}
              </div>
                 <div className="col-md-3">
               {this.displayhoras("Cierre Tarde",this.state.viernes_horario_tarde_cierre,24)}
               </div>
 
              </div>



               {this.displaytoogle("Sábado",this.state.sabado_estado,25)}
               <div className="row">
               
               <div className="col-md-3">


              {this.displayhoras("Apertura Mañana",this.state.sabado_horario_manana_apertura,26)}
              </div>
                 <div className="col-md-3">

              {this.displayhoras("Cierre Mañana",this.state.sabado_horario_manana_cierre,27)}
              </div>
                 <div className="col-md-3">
              {this.displayhoras("Apertura Tarde",this.state.sabado_horario_tarde_apertura,28)}
              </div>
                 <div className="col-md-3">
               {this.displayhoras("Cierre Tarde",this.state.sabado_horario_tarde_cierre,29)}
               </div>
 
             </div>
 


               {this.displaytoogle("Domingo",this.state.domingo_estado,30)}

               <div className="row">
               
               <div className="col-md-3">

              {this.displayhoras("Apertura Mañana",this.state.domingo_horario_manana_apertura,31)}
              </div>
                 <div className="col-md-3">
              {this.displayhoras("Cierre Mañana",this.state.domingo_horario_manana_cierre,32)}
              </div>
                 <div className="col-md-3">
              {this.displayhoras("Apertura Tarde",this.state.domingo_horario_tarde_apertura,33)}
              </div>
                 <div className="col-md-3">
               {this.displayhoras("Cierre Tarde",this.state.domingo_horario_tarde_cierre,34)}
               </div>
 
              </div>

 






      </div>

         
     
      )


  } 
}
export default Horario;

Horario.propTypes = {
    updateAction:PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    theKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/fields/Horario.js